module.exports = __webpack_public_path__ + "static/media/sentres.7c07be28.svg";